import React from "react";

import { mdiChevronRight, mdiHome } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";

import type { JSX } from "react";

export interface Breadcrumb {
  name: string;
  url?: string;
}

interface IBreadcrumbs {
  breadcrumbs: Breadcrumb[];
  height?: number;
}

function Breadcrumbs({ breadcrumbs, height }: IBreadcrumbs): JSX.Element {
  const navLinkClassNames = classNames(
    "hover:text-foreground focus:text-foreground text-muted-foreground max-w-[300px] truncate",
  );

  return (
    <div
      className="overflow-hidden transition-all duration-300"
      style={{ height }}
    >
      <div className="flex items-center gap-[0.46875rem]">
        <NavLink className={navLinkClassNames} to="/">
          <Icon path={mdiHome} size={1.25} />
        </NavLink>
        <Icon className="text-subtle" path={mdiChevronRight} size={0.625} />
        {breadcrumbs.map((breadcrumb, index) => (
          <div
            key={`${breadcrumb.name}-${breadcrumb.url}`}
            className="flex items-center gap-[0.46875rem] last-of-type:overflow-hidden"
          >
            {breadcrumb.url ? (
              <NavLink
                className={navLinkClassNames}
                title={breadcrumb.name}
                to={breadcrumb.url}
              >
                {breadcrumb.name}
              </NavLink>
            ) : (
              <span className="truncate">{breadcrumb.name}</span>
            )}
            {breadcrumbs.length - 1 !== index && (
              <Icon
                className="text-subtle"
                path={mdiChevronRight}
                size={0.625}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Breadcrumbs;
